import { assignSealed } from "./utils/assignSealed.js";
export class Api {
    constructor(entrypoint, options = {}) {
        this.entrypoint = entrypoint;
        assignSealed(this, options);
    }
}
//# sourceMappingURL=Api.js.map